import { Events } from '@phx-husky/auth-service';

type AuthUser = object | null | undefined;

let authUser: AuthUser;
const listeners: Array<(user: AuthUser) => void> = [];

const setAuthUser = (user: AuthUser) => {
  authUser = user;
  listeners.forEach((listener) => listener(user));
};

const subscribe = (listener: (user: AuthUser) => void) => {
  listeners.push(listener);

  return () => {
    const index = listeners.indexOf(listener);
    listeners.splice(index, 1);
  };
};

const getAuthUser = () => authUser;

const init = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener(Events.onAuthStateChange, (event: Event) => {
    const { detail } = event as CustomEvent;
    setAuthUser(detail?.user ?? null);
  });
};

if (typeof window !== 'undefined') {
  init();
}

export const authStore = {
  init,
  getAuthUser,
  subscribe,
};
